import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { ThemeProvider } from 'styled-components';
import { Box, Flex } from 'grid-styled';
import { color } from '../styles/helpers/variables';
import { StartPageBlock } from '../styles/blocks/StartPageBlock';
import InformationCard from './InformationCard';
import { SITE_ROOT_URL } from '../constants/endpoints';
import LinedHeading from './LinedHeading';
import { Conditional } from './Conditional';

export const InformationCards = props => {
  const { headline, cards, py, mb } = props;

  // if there are no cards, don't render anything, not even the headline
  if (cards.isEmpty()) return false;

  return (
    <StartPageBlock.Section backgroundColor={color.lightGrey} py={py} mb={mb}>
      <StartPageBlock.Container>
        <Conditional show={!!headline}>
          <LinedHeading bgColor={color.lightGrey}>{headline}</LinedHeading>
        </Conditional>

        <ThemeProvider
          theme={{
            breakpoints: ['500px', '730px', '800px', '1200px']
          }}
        >
          <Flex flexWrap="wrap" mx={['0px', '-8px', '-11px']}>
            {cards.map((data, index) => {
              // data can be structured differently if it's a normal CMS page or a LinkPage
              // therefor we define all our InformationCard props up here to simplify things
              const url = data.get('url');
              const imageSrc = data.getIn(['listImage', 'url']) || data.getIn(['image', 'url']);
              const imageAlt = data.getIn(['listImage', 'alt']) || data.getIn(['image', 'alt']);
              const label = data.get('listText') || data.get('label');
              const title = data.get('listTitle') || data.get('title');

              // don't return anything if we are missing important data
              if (!imageSrc || !label || !title || !url) return null;

              return (
                <Box key={url} width={[1, 1, 1, 1 / 3]} py={['5px', '8px', '11px']} px={['0px', '8px', '11px']}>
                  <InformationCard
                    url={url}
                    imageSrc={`${SITE_ROOT_URL + imageSrc}?width=900&heightRatio=1&mode=crop`}
                    imageAlt={imageAlt}
                    label={label}
                    title={title}
                    lastChild={index === cards.size - 1}
                  />
                </Box>
              );
            })}
          </Flex>
        </ThemeProvider>
      </StartPageBlock.Container>
    </StartPageBlock.Section>
  );
};

InformationCards.defaultProps = {
  headline: undefined,
  cards: Map(),
  py: 0,
  mb: 0
};

InformationCards.propTypes = {
  headline: PropTypes.string,
  cards: PropTypes.instanceOf(Map),
  py: PropTypes.number,
  mb: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/components/InformationCards.js